<template>
  <div class="container">
    <el-row :gutter="10" class="header">
      <el-button
        type="text"
        @click="handleSelect('backDataAccSummary')"
        :class="currentRouter === 'backDataAccSummary' ? 'active' : ''"
        >准确率概览</el-button
      >
      <el-button
        type="text"
        :class="currentRouter === 'backDataAccByCanteen' ? 'active' : ''"
        @click="handleSelect('backDataAccByCanteen')"
        >准确率查询</el-button
      >
    </el-row>
    <el-row :gutter="10" v-if="filterWrapperShow">
      <el-col :span="10">
        <filter-wrapper
          :filter-item="{
            searchBox: true,
            canteen: true,
            eatery: true,
            datetime: true
          }"
        ></filter-wrapper>
      </el-col>
      <el-col :span="2">
        <el-button type="primary" @click="getBackDataAcc">刷新</el-button>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <h3>
        数据来源: {{ canteen.canteen_name }}
        <span class="primary">{{ dateTime | tsTodate }}</span>
        <el-button @click="backToTaskList" size="mini" type="text"
          >查看任务历史</el-button
        >
      </h3>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="14">
        <div class="chart-wrapper" v-if="backDataAcc.length > 0">
          <div>
            <p>
              准确率红线
              <span class="line line-danger"></span>
            </p>
            <p>
              平均准确率
              <span class="line line-primary"></span>
            </p>
          </div>
          <zxEchart
            class="chart-item chart-wrapper"
            :series="chartsData"
            :avarage="avarageAcc"
            @barClick="barClick"
          ></zxEchart>
        </div>
        <span v-else>暂无回测数据</span>
      </el-col>
      <el-col :span="10" v-if="backDataAcc.length > 0">
        <el-table :data="tableData" style="width: 100%" height="500px">
          <el-table-column header-align="center" align="center" label="名称">
            <template slot-scope="scope">{{
              scope.row.dish_name || scope.row.dish_name || "暂无"
            }}</template>
          </el-table-column>
          <el-table-column header-align="center" align="center" label="例图">
            <template slot-scope="scope">
              <classDishWrapper
                :image="scope.row"
                class="classDishWrapper"
              ></classDishWrapper>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="碗碟删除数量"
          >
            <template slot-scope="scope">{{
              scope.row.deleted > scope.row.total
                ? scope.row.total
                : scope.row.deleted
            }}</template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="total"
            label="碗碟总数"
          ></el-table-column>
          <el-table-column header-align="center" align="center" label="准确率">
            <template slot-scope="scope">
              <!--<img :src="scope.row.dish_acc" alt="" width="50">-->
              {{ scope.row.dish_acc ? `${scope.row.dish_acc * 100}%` : "0%" }}
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import zxEchart from './/zxEchart';
import filterWrapper from '_c/filterWrapper';
import {mapActions, mapGetters, mapMutations} from 'vuex';
import {apiGetAccByCanteen, apiGetLabelTaskidByBar} from '@/api';
import util from '@/lib/util';
import moment from 'moment';

import classDishWrapper from '_c/classDishWrapper';

export default {
  name: "backDataAcc",
  components: {
    zxEchart,
    filterWrapper,
    classDishWrapper
  },
  data() {
    return {
      backDataAcc: []
    };
  },
  mounted() {
    this.setSubTitle("准确率分析");
    this.setModelList(this.canteen.canteen_id);
    this.getBackDataAcc();
    // this.
  },
  filters: {
    tsTodate(ts) {
      return moment(ts * 1000).format("YYYY-MM-DD");
    }
  },
  methods: {
    ...mapMutations(["emitLoading", "removeLoading", "setSubTitle"]),
    ...mapActions(["setModelList"]),
    handleSelect(tab) {
      // console.log(tab, event);
      console.log(tab);
      // console.log(tab);

      this.$router.push({
        name: tab
      });
    },
    async barClick(idx) {
      // console.log('assssssss');
      // console.log(id);
      const choose_class_id = this.chartsData[idx].class_id;
      try {
        let { label_task_uuid_list } = await apiGetLabelTaskidByBar({
          canteen_id: this.canteen.canteen_id,
          day_ts: this.dateTime,
          class_id: choose_class_id
        });
        label_task_uuid_list = this.$_.uniq(label_task_uuid_list);
        if (label_task_uuid_list.length > 1) {
          this.$message.warning("多个批次包含此碗碟, 正在跳转到第一个碗碟");
          this.$router.push({
            name: "taskHistoryRecheck",
            params: {
              checkMode: false,
              class_id: choose_class_id,
              taskInfo: {
                day_ts: this.dateTime,
                label_task_uuid: label_task_uuid_list,
                ...this.canteen
              }
            }
          });
        } else if (label_task_uuid_list.length === 1) {
          this.$message.warning("正在跳转");
          this.$router.push({
            name: "taskHistoryRecheck",
            params: {
              checkMode: false,
              class_id: choose_class_id,
              taskInfo: {
                day_ts: this.dateTime,
                label_task_uuid: label_task_uuid_list,
                ...this.canteen
              }
            }
          });
        }
      } catch (e) {}
    },
    backToTaskList() {
      this.$router.push({
        name: "taskHistory",
        params: {
          canteen: this.canteen.canteen_name
        }
      });
    },
    async getBackDataAcc() {
      try {
        let res = await apiGetAccByCanteen(
          this.canteen.canteen_id,
          this.dateTime
        );
        this.backDataAcc = res.dish_acc_list;
        this.backDataAcc.forEach((a, idx) => {
          let res = this.$_.find(this.modelList, b => {
            return a.class_id === b.class_id;
          });
          console.log(res);
          if (res) {
            // a.dish_image_url = res.dish_image_url;
            this.$set(a, "dish_image_url", res.dish_image_url);
            this.$set(a, "dish_desc", res.dish_desc);
            this.$set(a, "dish_native_name", res.dish_native_name);
            this.$set(a, "dish_name", res.dish_name);
            this.$set(a, "dish_type", res.dish_type);
          }
        });
      } catch (e) {
        console.log(e);
        this.$message.error("获取失败");
      }
      // try {
      //   let { dish_acc_info_list } = await apiGetBackDataAcc({
      //     canteen_id: this.canteen.canteen_id,
      //     apiKey: this.apiKey,
      //     date_ts: this.dateTime
      //   });
      //   this.backDataAcc = dish_acc_info_list;
      //   let { class_admin_list } = await apiGetClassDishByClassId(
      //     this.backDataAcc.map(a => a.class_id)
      //   );
      //   this.backDataAcc.forEach((a, idx) => {
      //     let res = this.$_.find(class_admin_list, b => {
      //       return a.class_id === b.class_id;
      //     });
      //     if (res) {
      //       // a.dish_image_url = res.dish_image_url;
      //       this.$set(a, "dish_image_url", res.dish_image_url);
      //       this.$set(a, "dish_desc", res.dish_desc);
      //       this.$set(a, "dish_native_name", res.dish_native_name);
      //       this.$set(a, "dish_type", res.dish_type);
      //     }
      //   });
      // } catch (e) {
      //   console.log(e);
      //   this.$message.error("查询准确率失败");
      // }
    }
  },
  computed: {
    ...mapGetters(["listQuery"]),

    filterWrapperShow() {
      return !(this.$route.params && this.$route.params.canteen);
    },
    canteen() {
      if (this.filterWrapperShow) {
        return this.listQuery.canteen;
      } else {
        return this.$route.params.canteen;
      }
    },
    modelList() {
      // if (this.filterWrapperShow) {
      //   return this.$store.getters.modelList;
      // } else {
      //   return this.$route.params.modelList;
      // }
      return this.$store.getters.modelList;
    },
    dateTime() {
      if (this.filterWrapperShow) {
        return util.dateToUnixtimestamp(this.listQuery.datetime, 0);
      } else {
        return this.$route.params.dateRange.start_ts;
      }
    },
    userinfo() {
      return this.$store.getters.userinfo();
    },
    apiKey() {
      return this.userinfo.api_key;
    },
    tableData() {
      let data = this.$_.cloneDeep(this.chartsData);
      return data.reverse();
    },
    chartsData() {
      let list = this.backDataAcc;
      list.forEach(a => {
        a.dish_name =
          // a.dish_name || a.dish_native_name + "(碗碟库)" || "暂无名称";
          a.dish_name
            ? a.dish_name
            : a.dish_native_name
            ? a.dish_native_name + "(碗碟库)"
            : "暂无名称";
      });
      list = this.$_.orderBy(list, "dish_acc", "desc");
      return list;
    },
    avarageAcc() {
      let total = 0;
      let deleted = 0;
      this.backDataAcc.forEach(a => {
        deleted += +a.deleted;
        total += +a.total;
        console.log(a.total);
      });
      console.log(deleted);
      // count = Math.round(count);
      return (1 - deleted / total).toFixed(2);
      // return total;
    }
  },
  watch: {
    listQuery: {
      handler() {
        this.getBackDataAcc();
      },
      deep: true
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  .header {
    position: absolute;
    top: -40px;
    left: 120px;
    .active {
      color: #000;
    }
  }
  .chart-wrapper {
    .chart-item {
      width: 50vw;
      height: 400px;
    }
  }
  .line {
    display: inline-block;
    border-top: 2px solid #409eff;
    width: 100px;
    vertical-align: center;
    &.line-danger {
      border-top: 2px solid #f56c6c;
    }
  }
  .classDishWrapper {
    width: 50px;
    height: 50px;
  }
}
</style>
